const dataCards = [
  {
    id: 1,
    title: 'E-book: Todo lo que debes saber sobre el bullying',
    items: [
      'Contenido informativo e interactivo.',
      '8 capítulos.',
      'Perfecto para estudiantes, profesores y padres.',
    ],
    link: './descargas/manual-antibullyng.pdf',
    forAccess: 'acceder al Ebook',
    textDownload: 'tu Ebook',
    requireLogin: true,
  },
  {
    id: 2,
    title: 'Material descargable para colegios y padres',
    items: ['Infográficos', 'Posters para colorear'],
    link: './descargas/descargables-loving.pdf',
    forAccess: 'acceder al contenido',
    textDownload: 'tu Material',
    requireLogin: false,
  },
  {
    id: 3,
    title: `Set de stickers de Whatsapp`,
    items: [],
    link: 'https://sticker.ly/s/8DWJ8R',
    forAccess: 'acceder al contenido',
    textDownload: 'tus stickers',
    requireLogin: false,
  },
]

export default dataCards
